export default __webpack_public_path__ + "static/media/AdobeStock_390584164.1663035f.jpg";